<template>
  <div style="width: 100%; height: 100%">

    <div class="centered-child" style="padding-bottom: 16px">
      <div style="width: 100%; max-width: 200px">
      <img src="/static/justice-scale.svg" width="100%">
      </div>
    </div>

    <h2>Your file cannot be processed</h2>

    <p>We cannot work on your file for an appeal procedure after a visa refusal. There are different reasons :</p>
    <ul>
      <li>The appeal has to be done within the <b>2 months after </b> your visa refusal or after your appeal to the Appeals Board on Visa Refusals.</li>
      <li>You indicated that your visa has not been refused ! We can't do anything for you</li>
    </ul>

    <p>
    If you have made a mistake in your answers , you can <router-link to="/">restart</router-link> the questionnaire
    or contact us by email <a @click="onClickContact()">contact-visa@getmyvisatofrance.com</a> to ask for our expert opinion.
    </p>

    <div class="centered-child" style="margin-top: 0px; align-items: center; flex-direction: column">
      <md-button class="md-raised md-primary large-button" @click="onClickContact()">Contact us</md-button>
    </div>

  </div>
</template>


<script>
import ServiceAccess from '../service/ServiceAccess'

export default {
  created: function () {
    global.navigationBarBus.$on('navigation-back', this.prevScreen)
    global.navigationBarBus.$emit('navigation-display-back', true)
    global.navigationBarBus.$emit('display-save', false)

    ServiceAccess.instance.track(this.$route.params.sessionId, 'screen-ko', {kind: 'N/A'})
  },
  destroyed: function () {
    global.navigationBarBus.$off('navigation-back', this.prevScreen)
  },

  methods: {
    prevScreen: function () {
      this.$router.back()
    },
    onClickContact: function () {
      global.LC_API.open_chat_window()
    }

  }
}
</script>



// WEBPACK FOOTER //
// ScreenRefused.vue?b37c254c